import React from "react";
import { connect } from "react-redux";
import { Actions as FSS_REPORT_ACTIONS } from "../../store/actions/fssReportActions";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { validateFloat } from "@/components/common/validation/Validators";
import { useEffect } from "react";
import { format } from "date-fns";

const CISModal = ({ modalStatus, closeModal, saving, saveCISDeductions, currency }) => {
	const [cisDeductions, setCISDeductions] = useState(modalStatus?.cisDeductionsThisMonth);

	useEffect(() => {
		if (modalStatus) setCISDeductions(modalStatus?.cisDeductionsThisMonth || modalStatus?.cisDeductions || 0);
	}, [!!modalStatus]);

	if (!modalStatus) return <></>;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "scroll" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className="block-header bg-success">
							<ul className="block-options">
								<li>
									<button
										className="close"
										type="button"
										aria-label="Close"
										onClick={() => closeModal()}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">
								CIS Deductions - {format(new Date(modalStatus.from), "MMMM")} {modalStatus.year}
							</h3>
						</div>
						<div className="modal-body">
							<div className="col-xs-12">
								<p className="pb-8">
									You are viewing the {modalStatus?.type?.toUpperCase()} for{" "}
									{format(new Date(modalStatus.from), "MMMM")}, {modalStatus.year}. Updating this
									value will affect the CIS Deductions for both the P30 & P32 (Employment Payment
									Summary). These equivalent PDF reports will then be regenerated & updated.
								</p>
								<div className="clearfix" />
								<div className="col-xs-6 form-material pl-0">
									<div style={{ position: "absolute", top: 8 }}>{currency}</div>
									<input
										style={{ paddingLeft: "1rem" }}
										type="text"
										className="form-control form-input"
										value={cisDeductions}
										onChange={(e) => {
											setCISDeductions(validateFloat(e.target.value));
										}}
									/>
									<label>CIS Deductions This Month</label>
								</div>
							</div>
							<div className="row">
								<div className="col-xs-12 text-right">
									<button
										disabled={saving}
										className="btn btn-success pull-right"
										type="button"
										id="regenerate-forms-btn"
										style={{ marginLeft: 10 }}
										onClick={() => saveCISDeductions(cisDeductions)}
									>
										{saving ? "Saving..." : "Save CIS Deductions"}
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
    const modalStatus = state.taxForms?.cisModal;
	const saving = state.taxForms?.cisDeductionsSaving?.includes(modalStatus?.id);

	return {
		modalStatus,
        saving,
		currency: state.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
    saveCISDeductions: (value) => dispatch(FSS_REPORT_ACTIONS.saveCISDeductions(value)),
	closeModal: () => dispatch(FSS_REPORT_ACTIONS.openCISModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CISModal);
